'use client';
import ChangeManager from '@/components/ChangeManager';
import { useSearchParams } from 'next/navigation';

const Index = () => {
	// const { data } = useQuery({
	// 	queryKey: ['employees'],
	// 	queryFn: async () => [],
	// });
	// console.log('Index', data);
	const searchParams = useSearchParams();
	const showNames = (searchParams?.get('showNames') || 'true') === 'true';
	return <ChangeManager showNames={showNames} />;
};

export default Index;
